import {ROUTES} from '../../../config/index.js'

export async function getInitialProps({context: {domain, pde, user}, routeInfo: {location}}) {
  const {
    pathname,
    query: {adId, tradeId}
  } = location

  const config = domain.get('config')
  const {AlreadyCancelledTradeTransactionsError} = config.get('COMMON').ERRORS

  const isPaymentFail = pathname === ROUTES.TRANSACTION.BUYER_PAYMENT_FAIL
  const isPaymentSuccess = pathname === ROUTES.TRANSACTION.BUYER_PAYMENT_SUCCESS

  const [getTradeDataError, getTradeDataResponse] = await domain
    .get('get_trade_data_transactions_use_case')
    .execute({tradeId})

  if (getTradeDataError instanceof AlreadyCancelledTradeTransactionsError) {
    return {
      __HTTP__: {
        redirectTo: ROUTES.USER.MESSAGES
      }
    }
  }

  const newState = {
    showTransactionBuyerPaymentFailModal: isPaymentFail,
    showTransactionBuyerPaymentSuccessModal: isPaymentSuccess,
    adId,
    sellerName: getTradeDataResponse?.sellerName
  }

  const [error, response] = await domain
    .get('get_messaging_conversation_id_user_use_case')
    .execute({entityId: adId, buyerId: getTradeDataResponse?.buyerId, sellerId: getTradeDataResponse?.sellerId})

  if (error !== null) {
    return {
      pathname: ROUTES.USER.MESSAGES,
      newState
    }
  }
  return {
    pathname: `/user/messages/#/id/${response.conversationId}`,
    newState
  }
}
